<div class="kt-login__body">
	<div class="kt-login__form p-5">
		<img class="kt-login_logo pb-5" src="/assets/media/homepage/logo_suumo.jpg" width="225">
		<form class="kt-form m-0" [formGroup]="loginForm" autocomplete="off">
			<div class="form-group">
				{{ 'AUTH.INPUT.EMAIL' | translate }}
				<mat-form-field appearance="fill" floatLabel="never">
					<input matInput type="email" placeholder="{{ 'AUTH.INPUT.EMAIL' | translate }}" formControlName="email" autocomplete="off"/>
				</mat-form-field>
				<div *ngIf="isControlHasError('email','required')" class="alert alert-danger">
					{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
				</div>
				<div *ngIf="isControlHasError('email','email')" class="alert alert-danger">
					{{ 'AUTH.VALIDATION.INVALID_FIELD' | translate }}
				</div>
				<div *ngIf="isControlHasError('email','minlength')" class="alert alert-danger">
					{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3
				</div>
				<div *ngIf="isControlHasError('email','maxlength')" class="alert alert-danger">
					{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 320
				</div>
			</div>
			<div class="form-group">
				{{ 'AUTH.INPUT.PASSWORD' | translate }}
				<mat-form-field appearance="fill" floatLabel="never">
					<input matInput type="password" placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}" formControlName="password" autocomplete="off"/>
				</mat-form-field>
				<div *ngIf="isControlHasError('password','required')" class="alert alert-danger">
					{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
				</div>
				<div *ngIf="isControlHasError('password','minLength')" class="alert alert-danger">
					{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3
				</div>
				<div *ngIf="isControlHasError('password','maxLength')" class="alert alert-danger">
					{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100
				</div>
				<div *ngIf="isControlHasError('password','wrongPassword')" class="alert alert-danger">
					{{ 'AUTH.VALIDATION.INVALID_LOGIN' | translate }}
				</div>
			</div>
			<div class="kt-login__button pb-5">
				<button (click)="submit()" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}" id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary">{{ 'AUTH.LOGIN.BUTTON' | translate }}</button>
			</div>
            <div *ngIf="notices.length > 0">
                <ul *ngFor="let notice of notices" class="list-unstyled">
                    <li class="ps-3"><span class="text-danger ms-1">New</span>{{notice}}</li>
                </ul>
            </div>
			<div class="d-flex flex-row justify-content-center"><a routerLink="/auth/forgot-password" [queryParams]="{loginType: 'suumo'}">パスワードをお忘れですか？</a></div>
		</form>
		<span style="color: #ccc; position: absolute; bottom: 10px; right: 10px;">Version 1.5.0</span>
	</div>
</div>
